import React from "react";
import { Button, Form, Grid, Icon } from "semantic-ui-react";
import { getDropdownOptions, handleInputType, isValidGuarantorAccessLevel } from "../../../Helpers";
import { getIsWhiteLabeled } from "../../../helpers/PermissionHelper";
import { BrokerConstants } from "../../constants/BrokerConstants";
import { GlobalConstants } from "../../constants/GlobalConstants";
import BCEmptyState from "../../ui/BCEmptyState";
import BCFormInput from "../../ui/BCFormInput";
import BCTable from "../../ui/BCTable";
import BCValidationMessage from "../../ui/BCValidationMessage";

interface IBPLoanGuarantorListContentProps {
  applicationId: any;
  applicationMetadata: any;
  brokerColor: any;
  borrowerApplicationInfo: any;
  permissions: any;
  allowEdit: boolean;
  organizationContactId: any;
  selectedBrokerGuarantors: any;
  setSelectedBrokerGuarantors: any;
  invalidProps: any;
  setInvalidProps: any;
  setIsInteriorCardLoading: any;
  brokerGuarantors: any;
  setBrokerGuarantors: any;
  isBrokerGuarantorSelected: any;
  setIsBrokerGuarantorSelected: any;
  getGuarantorsAsync: any;
  guarantorSearch: any;
  setGuarantorSearch: any;
  isGreaterThanMobile: any;
  setSelectedGuarantorId: any;
  setIsLoading: any;
  handleBrokerGuarantorDelete: any;
  handleBrokerGuarantorInvite: any;
  handleBrokerGuarantorModal: any;
  handlePatchApplicationGuarantor: any;
}

const BPLoanGuarantorListContent = ({...props}: IBPLoanGuarantorListContentProps) => {
  const isViewOnly = isValidGuarantorAccessLevel(props.permissions, "GuarantorWhiteLabeledApplication", "read", props.selectedBrokerGuarantors ? props.selectedBrokerGuarantors : [], props.organizationContactId, GlobalConstants.AccessLevelIds.VIEW_ONLY);
  const isLimited = isValidGuarantorAccessLevel(props.permissions, "GuarantorWhiteLabeledApplication", "read", props.selectedBrokerGuarantors ? props.selectedBrokerGuarantors : [], props.organizationContactId, GlobalConstants.AccessLevelIds.LIMITED);

  const handleAddBrokerGuarantor = () => {
    if (props.guarantorSearch !== "") {
      props.handleBrokerGuarantorModal();
    }
  };

  const handleGuarantorSearchChange = async (value, field, charLimit = undefined as number | undefined) => {
    const guarantorSearchValue = handleInputType("string", value, undefined, undefined, charLimit);
    props.setInvalidProps([]);
    props.setGuarantorSearch(guarantorSearchValue);
    props.setIsBrokerGuarantorSelected(false);
    const metaGuarantors = (props.applicationMetadata && props.applicationMetadata.guarantors) ? props.applicationMetadata.guarantors : [];
    if (guarantorSearchValue !== "" && metaGuarantors && metaGuarantors.length > 0) {
      const filteredGuarantors = metaGuarantors.filter(x => ((x.firstName && ((x.firstName).toLowerCase().includes(guarantorSearchValue.toLowerCase()))) ||
        (x.lastName && (x.lastName).toLowerCase().includes(guarantorSearchValue.toLowerCase())) ||
        (x.email && (x.email).toLowerCase().includes(guarantorSearchValue.toLowerCase()))));
      props.setBrokerGuarantors(filteredGuarantors);
    }
    else if (guarantorSearchValue === "" && !props.borrowerApplicationInfo.borrowerOrganizationId) {
      props.setBrokerGuarantors([]);
    }
  };

  const handleGuarantorSearchClear = () => {
    props.setIsBrokerGuarantorSelected(true);
    props.setGuarantorSearch("");
  };

  const handleDoubleFilterGuarantorSuggestions = (guarantorSearch) => {
    const results = [] as any[];
    let resultLimit = 6;
    let filteredGuarantors = (props.applicationMetadata && props.applicationMetadata.guarantors) ? props.applicationMetadata.guarantors : [];
    if (guarantorSearch && guarantorSearch !== "") {
      filteredGuarantors = props.brokerGuarantors;
    }

    if (filteredGuarantors && filteredGuarantors.length > 0) {
      filteredGuarantors.forEach(brokerGuarantor => {
        const foundSelectedGuarantorIndex = props.selectedBrokerGuarantors.findIndex(x => x.email === brokerGuarantor.email);
        if (resultLimit > 0 && foundSelectedGuarantorIndex === -1) {
          const guarantorObj = {
            id: brokerGuarantor.id,
            email: brokerGuarantor.email,
            firstName: brokerGuarantor.firstName,
            lastName: brokerGuarantor.lastName,
            status: brokerGuarantor.status
          };

          results.push({
            key: brokerGuarantor.id,
            title: `${brokerGuarantor.firstName} ${brokerGuarantor.lastName}`,
            description: brokerGuarantor.email,
            value: guarantorObj
          });

          resultLimit--;
        }
      });
    }

    return results;
  };

  const handleGuarantorSelect = async (result) => {
    if (result && result.value) {
      props.setInvalidProps([]);
      const foundSelectedGuarantorIndex = props.selectedBrokerGuarantors.findIndex(x => x.email === result.value.email);
      if (foundSelectedGuarantorIndex === -1 && result.value) {
        props.selectedBrokerGuarantors.push({
          id: result.value.id,
          firstName: result.value.firstName,
          lastName: result.value.lastName,
          email: result.value.email,
          accessLevelId: result.value.accessLevelId,
          status: result.value.status
        });
  
        props.setSelectedBrokerGuarantors([...props.selectedBrokerGuarantors]);
      }
  
      props.setGuarantorSearch("");
      props.setIsBrokerGuarantorSelected(true);
      props.setIsLoading(true);
      if (props.borrowerApplicationInfo.id, props.borrowerApplicationInfo.borrowerOrganizationId && props.selectedBrokerGuarantors && props.selectedBrokerGuarantors.length > 0) {
        await props.handlePatchApplicationGuarantor();
        await props.getGuarantorsAsync(props.borrowerApplicationInfo.id);
      }

      props.setIsLoading(false);
    }
  };

  const handleGuarantorSearchKeyDown = async (e) => {
    const windowPathname = window.location.pathname.toLocaleLowerCase();
    if (e.keyCode === 13 && windowPathname.includes(BrokerConstants.InteriorCardTabs.Guarantors.name.toLocaleLowerCase()) && !props.isBrokerGuarantorSelected && props.guarantorSearch === "") {
      handleGuarantorSearchClear();
    }
    else if (e.keyCode === 13 && windowPathname.includes(BrokerConstants.InteriorCardTabs.Guarantors.name.toLocaleLowerCase()) && !props.isBrokerGuarantorSelected) {
      await props.handleBrokerGuarantorModal();
    }
    else if (e.keyCode === 27) {
      handleGuarantorSearchClear();
    }
  };

  const handleGuarantorFormChange = async (value, field, guarantor) => {
    const foundGuarantor = [...props.selectedBrokerGuarantors].find(g => g.id === guarantor.id);
    foundGuarantor[field] = value;
    const updatedGuarantorList = props.selectedBrokerGuarantors.map(oldGuarantor => {
      return oldGuarantor.id === guarantor.id ? foundGuarantor : oldGuarantor;
    });

    props.setSelectedBrokerGuarantors([...updatedGuarantorList]);
    props.setIsInteriorCardLoading(true);
    await props.handlePatchApplicationGuarantor();
    props.setIsInteriorCardLoading(false);
  };

  const formatGuarantorInviteButtonWord = (guarantor) => {
    if ([BrokerConstants.GuarantorInviteStatus.ACCEPTED, 
    BrokerConstants.GuarantorInviteStatus.DECLINED, 
    BrokerConstants.GuarantorInviteStatus.COMPLETED, 
    BrokerConstants.GuarantorInviteStatus.PENDING].indexOf(guarantor.status) > -1) {
      return "Resend Invite";
    }
    else {
      return "Invite Now";
    }
  };

  const formatGuarantors = (array) => {
    const formattedGuarantor = [] as any[];
    array && array.forEach((guarantor) => {
      const guarantorObj = {
        "First Name": guarantor.firstName && guarantor.firstName,
        "Last Name": guarantor.lastName && guarantor.lastName,
        "Email": guarantor.email && guarantor.email,
        "Access Level": <React.Fragment>
          <BCFormInput
            labelClass="gmr-background-label"
            type="dropdown"
            placeholder="Please Select"
            obj={guarantor}
            field="accessLevelId"
            fluid={false}
            value={guarantor.accessLevelId}
            dropdownOptions={getDropdownOptions(props.applicationMetadata.accessLevels, ["id"], "name")}
            handleFormChange={(value, field) => handleGuarantorFormChange(value, field, guarantor)}
            disabled={!props.allowEdit}
          />
        </React.Fragment>,
        "Status": (guarantor && guarantor.status === "BrokerInitiated") ? BrokerConstants.GuarantorInviteStatus.NOTSEND : guarantor.status ? guarantor.status : BrokerConstants.GuarantorInviteStatus.NOTSEND,
        "": <React.Fragment>
          <div className="guarantor-interior-filter-buttons">
            {(guarantor.status && guarantor.status !== BrokerConstants.GuarantorInviteStatus.DECLINED) && <Button
              className="table-button"
              icon
              color="green"
              inverted
              onClick={() => props.setSelectedGuarantorId(guarantor.id)}
              disabled={!props.allowEdit}
            >
              <div className="gmr-button-container">
                {props.isGreaterThanMobile && <div className="table-button-text">Review</div>}
              </div>
            </Button>}
            {(guarantor.status && guarantor.status !== BrokerConstants.GuarantorInviteStatus.COMPLETED) && <Button
              className="table-button"
              icon
              color="green"
              inverted
              onClick={() => props.handleBrokerGuarantorInvite(guarantor.id)}
              disabled={!props.allowEdit || !guarantor.accessLevelId}
            >
              <div className="gmr-button-container">
                {props.isGreaterThanMobile && <div className="table-button-text">{formatGuarantorInviteButtonWord(guarantor) ? formatGuarantorInviteButtonWord(guarantor) : "Invite Now"}</div>}
              </div>
            </Button>}
            {((props.selectedBrokerGuarantors.filter(guarantor => guarantor.statusLookupName === BrokerConstants.GuarantorInviteStatus.COMPLETED).length > 1 && guarantor.status === BrokerConstants.GuarantorInviteStatus.COMPLETED) || guarantor.status !== BrokerConstants.GuarantorInviteStatus.COMPLETED) && <Button
              className="table-button"
              icon
              color="red"
              inverted
              onClick={() => props.handleBrokerGuarantorDelete(guarantor.id)}
              disabled={!props.allowEdit}
            >
              <div className="gmr-button-container">
                <Icon name='trash' />
                {props.isGreaterThanMobile && <div className="table-button-text">Delete</div>}
              </div>
            </Button>}
          </div>
        </React.Fragment>
      };

      formattedGuarantor.push(guarantorObj);
    });

    return formattedGuarantor;
  };

  return (
    <React.Fragment>
      <Form className="primary-form" autoComplete="off">
        <Grid className="guarantor-interior-filter-grid">
          <Grid.Row className="application-row">
            {!(isViewOnly || isLimited) && <Grid.Column width={16}>
              <BCFormInput
                tooltip="Add the guarantors for the loan below. Once added they will recieve an email inviting them to review the application and to sign any necessary disclosures."
                label={props.guarantorSearch === "" ? "Add Guarantor" : ""}
                actionLabel="Add Guarantor"
                actionText={props.guarantorSearch !== "" ? "+ Add New Guarantor" : ""}
                labelAction={() => handleAddBrokerGuarantor()}
                type={GlobalConstants.FormInputTypes.SEARCH_FILTER}
                onSearchChange={(value, field) => handleGuarantorSearchChange(value, field)}
                value={props.guarantorSearch}
                renderSuggestions={handleDoubleFilterGuarantorSuggestions(props.guarantorSearch)}
                handleSearchSelect={(e, data) => handleGuarantorSelect(data.result)}
                isSearchOpen={!props.isBrokerGuarantorSelected}
                onSearchFocus={() => props.setIsBrokerGuarantorSelected(false)}
                noSearchResultsMessage="To add a new Guarantor, type their email address and press enter."
                searchClass="bc-search-input-full"
                handleSearchKeyDown={handleGuarantorSearchKeyDown}
                disabled={!props.allowEdit}
              />
              <BCValidationMessage
                invalidProps={props.invalidProps}
                prop="custom-broker-guarantor-email"
                propText="This email is invalid."
              />
            </Grid.Column>}
          </Grid.Row>
          {props.selectedBrokerGuarantors.length > 0 ? <Grid.Row>
            <Grid.Column width={16}>
              <BCTable
                data={formatGuarantors(props.selectedBrokerGuarantors)}
                dataRules={[{ field: "Id", rule: "hide" }]}
                thin
                required
                tooltip={<React.Fragment>
                  <div className="access-level-tooltip">
                    <span>Full Edit:</span>
                    <div className="access-level-tooltip-indent">Allows for full access to the loan and ability to edit the application. Individuals with this access level can add more Guarantors to the loan, but not see any personal identification information for those Guarantors.</div>
                    <p></p>
                    <span>View Only:</span>
                    <div className="access-level-tooltip-indent">Provides the ability to see the entire application (minus other Guarantor's personal identification information) and the ability to edit their own information.</div>
                    <p></p>
                    <span>Limited:</span>
                    <div className="access-level-tooltip-indent">Allows for a limited viewing of the application. Individuals with this access level will only be able to see the summary of the loan and edit their own information.</div>
                  </div>
                </React.Fragment>}
                dataSingleLine
                unstackable
                overflowX
                brokerColor={getIsWhiteLabeled() ? props.brokerColor : void 0}
              />
            </Grid.Column>
          </Grid.Row> : <Grid.Row>
            <Grid.Column width={16}>
              <BCEmptyState 
                icon="users"
                text="Looks like you haven't added any guarantors yet. Use the search above to add your guarantors."
              />
            </Grid.Column>
          </Grid.Row>}
        </Grid>
      </Form>
    </React.Fragment>

  );
};

export default BPLoanGuarantorListContent;